import { FileImageOutlined } from "@ant-design/icons";
import { Col, Form, Input, Row, Select } from "antd";
import { FormInstance } from "antd/lib/form";
import TextArea from "antd/lib/input/TextArea";
import Dragger from "antd/lib/upload/Dragger";
import { omit } from "lodash";
import React, { useCallback } from "react";

type FormType = {
  form: FormInstance<any>;
  values?: any;
  submit: (values: any) => void;
  data: any;
};

export const LineForm: React.FC<FormType> = (props) => {
  const { form, values, data, submit } = props;

  const {
    collectionBrands: { nodes: collectionBrands },
  } = data;

  const uploadProps = {
    maxCount: 1,
    accept: "image/*",
    listType: "picture-card",
    beforeUpload: () => {
      return false;
    },
  };

  const onValuesChange = useCallback(
    (changedValues) => {
      const fieldValues: any[] = [];
      if (changedValues.coverHorizontal && changedValues.coverHorizontal.file.status === "removed") {
        fieldValues.push({ name: ["coverHorizontal"], value: null });
      }
      if (changedValues.coverVertical && changedValues.coverVertical.file.status === "removed") {
        fieldValues.push({ name: ["coverVertical"], value: null });
      }
      form.setFields(fieldValues);
    },
    [form],
  );

  const onFinish = (values: any) => {
    const input = {
      ...omit(values, ["coverHorizontal", "coverVertical"]),
      coverHorizontal: values.coverHorizontal?.file,
      coverVertical: values.coverVertical?.file,
    };
    submit(input);
  };

  return (
    <Form layout="vertical" form={form} initialValues={values} onValuesChange={onValuesChange} onFinish={onFinish}>
      <Row gutter={[24, 0]}>
        <Col span={12}>
          <Form.Item name="code" label="Code" rules={[{ required: true, message: "is required" }]}>
            <Input />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item name="brandId" label="Brand" rules={[{ required: true, message: "is required" }]}>
            <Select>
              {collectionBrands.map((brand: any) => (
                <Select.Option key={brand.id} value={brand.id}>
                  {brand.code}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item name="nameIt" label="Name IT" rules={[{ required: true, message: "is required" }]}>
            <Input />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item name="nameEn" label="Name EN" rules={[{ required: true, message: "is required" }]}>
            <Input />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item name="descriptionIt" label="Description IT">
            <TextArea />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item name="descriptionEn" label="Description EN">
            <TextArea />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item name="color" label="Color" rules={[{ required: true, message: "is required" }]}>
            <Input />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item name="position" label="Position" rules={[{ required: true, message: "is required" }]}>
            <Input type="number" min={0} />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[24, 0]}>
        <Col span={8}>
          <Form.Item
            name="coverHorizontal"
            label="Cover horizontal"
            rules={[{ required: true, message: "is required" }]}
          >
            <Dragger {...uploadProps} defaultFileList={values?.coverHorizontal}>
              <div>
                <FileImageOutlined style={{ fontSize: "30px" }} />
                <div style={{ marginTop: 8 }}>Click or drop here</div>
              </div>
            </Dragger>
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item name="coverVertical" label="Cover vertical" rules={[{ required: true, message: "is required" }]}>
            <Dragger {...uploadProps} defaultFileList={values?.coverVertical}>
              <div>
                <FileImageOutlined style={{ fontSize: "30px" }} />
                <div style={{ marginTop: 8 }}>Click or drop here</div>
              </div>
            </Dragger>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};
